import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useAuth } from "context/AuthContext";

import AnalyticsDashboardContent from "./Analytics/AnalyticsDashboardContent";
import { resolveAnalyticsPersona } from "./Analytics/config/analyticsPersonas";

const getPortalLabel = (role) => {
  const r = (role || "").toLowerCase();
  switch (r) {
    case "admin":
      return "Admin";
    case "airport":
      return "Airport";
    case "nonprofit":
      return "Non-Profit";
    case "pilot":
      return "Pilot";
    case "user":
    default:
      return "User";
  }
};

function AnalyticsPage() {
  const auth = useAuth();
  // JWT custom claims (tokenRole) update immediately after profile switch + refreshAuth; profile.role can lag.
  const activeRole = auth.isGuest ? null : auth.tokenRole || auth.profile?.role || null;
  const profileRole = auth.isGuest ? "Guest" : activeRole || "User";
  const portalLabel = auth.isGuest ? null : getPortalLabel(profileRole);
  const analyticsPersona = resolveAnalyticsPersona(profileRole);

  return (
    <SoftBox py={{ xs: 3, md: 4 }}>
      {auth.isGuest && (
        <SoftBox mb={2.5}>
          <Alert severity="info" sx={{ borderRadius: "lg" }}>
            You are viewing the dashboard with sample charts and metrics. Sign in to see live data for your
            organization.
          </Alert>
        </SoftBox>
      )}
      <SoftBox mb={{ xs: 3, md: 4 }}>
        <SoftTypography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 1, lineHeight: 1.25 }}>
          {portalLabel ? `${portalLabel} analytics` : "Analytics"}
        </SoftTypography>
        <SoftTypography variant="body2" color="text" sx={{ lineHeight: 1.65, maxWidth: "40rem" }}>
          {portalLabel
            ? `Charts and KPIs matched to the ${portalLabel.toLowerCase()} role.`
            : "Community-facing metrics — sign in for a role-specific dashboard."}
        </SoftTypography>
      </SoftBox>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <AnalyticsDashboardContent
            key={`${analyticsPersona}-${auth.tokenEntityId ?? ""}-${auth.tokenEntityType ?? ""}`}
            persona={analyticsPersona}
          />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default AnalyticsPage;
